import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CNConsultation } from '../models/cnconsultation';
import { CNPrescription } from '../models/cnprescription';
import { CNPrescriptionEntry } from '../models/cnprescriptionentry';
import { SNItem } from '../models/snitem';
import { SNItemFactory } from '../models/snitemfactory';
import { SNItemTableService, SNItemTableControl, SNItemTableServiceCapability } from '../snitem-table/snitem-table-interface';
import { BecareService } from './becare.service';
import { PatientService } from './patient.service';
import { PrescriptionService } from './prescription.service';
import { ConsultationService } from './consultation.service';
import { UserStoreService } from './user-store.service';
import { UserConfigService } from './user-config.service';
import { EHealthService } from './e-health.service';

@Injectable({
  providedIn: 'root'
})
export class PrescriptionUiService implements SNItemTableService {

  private static instance: PrescriptionUiService = null;
  public prescriptions: CNPrescription[] = [];
  public prescription: CNPrescription;
  public consultation: CNConsultation;
  public data = new BehaviorSubject<CNPrescriptionEntry[]>([]);

  constructor(private patient: PatientService, private ehealth: EHealthService,
              private consultationsrv: ConsultationService,
              private userstore: UserStoreService,
              private userconfig: UserConfigService,
              private becare: BecareService) { }

  public static getInstance(): PrescriptionUiService {
    return PrescriptionUiService.instance;
  }

  loadStored() {
    const storedPrescription = this.userstore.load('prescription').subscribe(prescriptionStored => {
      if (prescriptionStored) {
        const prescriptionObj = JSON.parse(prescriptionStored);
        const factory = new SNItemFactory();
        const prescription: CNPrescription = factory.itemFromJson(prescriptionObj);
        if (prescription.key === 'SNItem.CNItem.CNPrescription') {
          if (typeof(prescriptionObj.childs) !== 'undefined') {
            // Add childs
            prescriptionObj.childs.forEach(aChild => {
              prescription.addChild(factory.itemFromJson(aChild), false);
            });
          }
          console.log('Prescription', prescription);
          this.prescription = prescription;
          this.prescriptions.push(prescription);
          this.consultation = new CNConsultation();
          // tslint:disable-next-line:max-line-length
          const entries: CNPrescriptionEntry[] = this.prescription.childs$('SNItem.CNItem.CNPrescriptionEntry') as CNPrescriptionEntry[];
          this.data.next(entries);
        }
      }
    });
  }

  addItem(item: CNPrescriptionEntry) {
    if (this.prescriptions.length === 0) {
      // No prescriptions ... create first one
      this.prescription = new CNPrescription();
      this.prescription.setProperty('healthagentid', this.userconfig.userid);
      this.prescription.setProperty('patientid', this.patient.patientid);
      this.prescriptions.push(this.prescription);
      this.consultation = new CNConsultation();
    }
    this.prescription.addChild(item, false);
    this.data.next(this.prescription.childs$('SNItem.CNItem.CNPrescriptionEntry') as CNPrescriptionEntry[]);
    this.userstore.store('prescription', this.prescription.toObj(true));
  }

  /**
   * SNItemTable Interface
   */

  snRegisterControl(control: SNItemTableControl) {
    console.log('register control');
  }

  snCapabilities(): SNItemTableServiceCapability[] {
    return [SNItemTableServiceCapability.search];
  }

  get fields() {
    return [];
  }

  store() {
    // tslint:disable-next-line:max-line-length
    this.consultationsrv.save(this.consultation, this.patient.patient).subscribe(consultation => {
      // tslint:disable-next-line:max-line-length
      this.becare.call('/fr/patient/' + this.patient.patient.id + '/consultation/' + consultation.id + '/prescription', [], this.prescription.toObj(true), 'post').subscribe(prescription => {
        console.log('prescription', prescription);
        this.userstore.clean('prescription').subscribe(result => {
          this.prescription = undefined;
          this.prescriptions = [];
        });
        this.userstore.clean('consultation').subscribe(result => {
          this.consultation = undefined;
        });
      });
    });
  }

  send() {
    this.ehealth.prescriptionsend(this.prescription).subscribe(result => {
      console.log(result);
    });
  }
}
